import type {
  DlsgPolicy,
  DlsgPolicyConfig,
  DlsgPolicyPlan,
} from '@repo/api-gw-sdk';
import { v4 as uuid } from 'uuid';

import type { Step } from '@/components/wizard/Step';

import { GatewayNameSelection } from './gatewayNameSelection';
import { StorageGatewayEditStep } from './storageGatewayEditStep';

export interface DlsgPolicyConfigWithIds
  extends Omit<DlsgPolicyConfig, 'pathPrefixes'> {
  id: string;
  pathPrefixes: { path: string; id: string }[];
}

interface DlsgPolicyPlanWithIds extends Omit<DlsgPolicyPlan, 'dlsgConfig'> {
  dlsgConfig: DlsgPolicyConfigWithIds[];
}

export interface DlsgPolicyWithIds extends Omit<DlsgPolicy, 'policyPlan'> {
  policyPlan: DlsgPolicyPlanWithIds;
}

export interface StorageGatewayWizardState {
  dlsgPolicy: DlsgPolicyWithIds;
  initialResourcesIds: string[];
  prefixesSelectionMode: 'all' | 'specific';
  allObjectsPolicyConfig: DlsgPolicyConfig;
}

export const addIdsToDlsgPolicy = (
  dlsgPolicy: DlsgPolicy
): DlsgPolicyWithIds => {
  return {
    ...dlsgPolicy,
    policyPlan: {
      ...dlsgPolicy.policyPlan,
      dlsgConfig: dlsgPolicy.policyPlan.dlsgConfig.map((config) =>
        addIdsToDlsgPolicyConfig(config)
      ),
    },
  };
};

export const addIdsToDlsgPolicyConfig = (
  config: DlsgPolicyConfig
): DlsgPolicyConfigWithIds => {
  return {
    ...config,
    id: uuid(),
    pathPrefixes: config.pathPrefixes.map((prefix) => ({
      path: prefix,
      id: uuid(),
    })),
  };
};

export const removeIdsFromDlsgPolicy = (
  dlsgPolicy: DlsgPolicyWithIds
): DlsgPolicy => {
  return {
    ...dlsgPolicy,
    policyPlan: {
      ...dlsgPolicy.policyPlan,
      dlsgConfig: dlsgPolicy.policyPlan.dlsgConfig.map(
        (config: DlsgPolicyConfigWithIds) => {
          return {
            isTruncateData: config.isTruncateData,
            migrationDelayHours: config.migrationDelayHours,
            pathPrefixes: config.pathPrefixes.map((prefix) => prefix.path),
          };
        }
      ),
    },
  };
};

export const StorageGatewayWizardFlow: Step<StorageGatewayWizardState> = {
  name: 'Storage Gateway Name Selection',
  Component: GatewayNameSelection,
  nonReturnable: true,
  next: [
    {
      name: 'Storage Gateway Edit',
      Component: StorageGatewayEditStep,
    },
  ],
};
